import {
    SET_FOLLOW_TRADE_LIST,
    SET_FOLLOW_ROW_IS_OPEN,
    SET_COPY_TIMER_ENDED,
    SET_ACTIVATION_SOCKET_UPDATE,
    SET_STATS_SOCKET_UPDATE,
    SET_COPY_INIT_STAT_VALUES,
    SET_STOP_COPY
} from "../actions/follow.trade.actions";

const initialState = {
    follow_trade_list: null,
    defaults: {
        trades_init_val: 5,
        trades_min_val: 1,
        invest_init_val: 5,
        invest_min_val: 5
    }
}

export default (state = initialState, action) => {

    if(action.type === SET_FOLLOW_TRADE_LIST) {
        return {...state, follow_trade_list: action.payload};
    }

    if(action.type === SET_FOLLOW_ROW_IS_OPEN) {

        const obj = state.follow_trade_list.find(obj => obj.rank === action.payload);
        if(!obj) return { ...state };
        
        obj.isOpen = !obj.isOpen;
        return {...state, follow_trade_list: [...state.follow_trade_list.map(obj => ({ ...obj }))]};
        
    }

    if(action.type === SET_COPY_TIMER_ENDED) {

        const arr = [...state.follow_trade_list.map(obj => ({ ...obj }))];
        const obj = arr.find(obj => obj.wallet === action.payload);
        
        if(obj) {
            delete obj.isCopied;
            delete obj.followEnd;
            delete obj.stat_amountPerCopy;
            delete obj.stat_pnl;
            delete obj.stat_winRatio;
            delete obj.stat_tradesCount;
            delete obj.stat_tradesNumber;
            delete obj.stat_winsCount;
        }

        return {...state, follow_trade_list: arr};

    }

    if(action.type === SET_ACTIVATION_SOCKET_UPDATE) {

        const arr = [...state.follow_trade_list.map(obj => ({ ...obj }))];
        const msg = action.payload;
        const obj = arr.find(item => item.wallet === msg.followedAddress);

        if(obj) {
            obj.isCopied = true;
            obj.followEnd = msg.endTime;
        }

        return {...state, follow_trade_list: arr};

    }

    if(action.type === SET_STATS_SOCKET_UPDATE) {
        
        const arr = [...state.follow_trade_list.map(obj => ({ ...obj }))];
        const msg = action.payload;
        
        for(const key in msg) {

            const stat = msg[key];
            const i = arr.findIndex(item => item.wallet === stat.followedWallet);
            if(i === -1 || !arr[i]) continue;

            // If trades still incomplete, add stat props to record
            if(stat.tradesCount !== stat.tradesNumber) {
                arr[i].status = stat.status;
                arr[i].sessionId = stat.sessionId;
                arr[i].stat_tradesCount = stat.tradesCount;
                arr[i].stat_tradesNumber = stat.tradesNumber;
                arr[i].stat_amountPerCopy = stat.investment;
                arr[i].stat_winsCount = stat.winsCount;
                arr[i].stat_pnl = stat.pnl.toFixed(2);
                arr[i].stat_winRatio = `${stat.winRatio.toFixed(2)}%`;
            }

            // Otherwise, reset record
            else {
                arr[i] = {
                    isOpen: arr[i].isOpen,
                    avatarUrl: arr[i].avatarUrl,
                    countryCode: arr[i].countryCode,
                    profit: arr[i].profit,
                    rank: arr[i].rank,
                    tradesCount: arr[i].tradesCount,
                    wallet: arr[i].wallet,
                    winningsCount: arr[i].winningsCount,
                    winRate: arr[i].winRate
                }
            }
            
        }

        return {...state, follow_trade_list: arr};

    }

    if(action.type === SET_COPY_INIT_STAT_VALUES) {

        const stats = action.payload;
        const arr = [...state.follow_trade_list.map(obj => ({ ...obj }))];
        const obj = arr.find(obj => obj.wallet === stats.followedWallet);
        
        if(obj) {
            obj.status = stats.status;
            obj.sessionId = stats.sessionId;
            obj.stat_tradesNumber = stats.stat_tradesNumber;
            obj.stat_tradesCount = stats.stat_tradesCount;
            obj.stat_amountPerCopy = stats.stat_amountPerCopy;
            obj.stat_winsCount = stats.stat_winsCount;
            obj.stat_pnl = stats.stat_pnl.toFixed(2);
            obj.stat_winRatio = `${stats.stat_winRatio.toFixed(2)}%`;
        }

        return {...state, follow_trade_list: arr};

    }

    if(action.type === SET_STOP_COPY) {

        const followedWallet = action.payload;
        const arr = [...state.follow_trade_list.map(obj => ({ ...obj }))];
        const i = arr.findIndex(item => item.wallet === followedWallet);
        
        if(i !== -1) {
            arr[i] = {
                isOpen: arr[i].isOpen,
                avatarUrl: arr[i].avatarUrl,
                countryCode: arr[i].countryCode,
                profit: arr[i].profit,
                rank: arr[i].rank,
                tradesCount: arr[i].tradesCount,
                wallet: arr[i].wallet,
                winningsCount: arr[i].winningsCount,
                winRate: arr[i].winRate
            };
        }

        return {...state, follow_trade_list: arr};

    }

    else return state;

};